document.addEventListener('DOMContentLoaded', function() {
    const wishlistButtons = document.querySelectorAll('.wishlist-button');

    wishlistButtons.forEach(button => {
        button.addEventListener('click', function() {
            const productHandle = this.dataset.productHandle;
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter(item => item !== productHandle);
                this.classList.remove('added');
                this.querySelector('.wishlist-text').textContent = 'Add to Wishlist';
            } else {
                wishlist.push(productHandle);
                this.classList.add('added');
                this.querySelector('.wishlist-text').textContent = 'Remove from Wishlist';
            }

            localStorage.setItem('wishlist', JSON.stringify(wishlist));
        });
    });

    // Mark wishlist items as "added" on page load
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist.forEach(productHandle => {
        const button = document.querySelector(`.wishlist-button[data-product-handle="${productHandle}"]`);
        if (button) {
            button.classList.add('added');
            button.querySelector('.wishlist-text').textContent = 'Remove from Wishlist';
        }
    });
});
